import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DriverActionExceptionClass;
function DriverActionException() {
  if (DriverActionExceptionClass === VOID) {
    class $ extends Exception() {
      constructor(message) {
        return new.target.new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$(message);
      }
      static new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$(message) {
        var $this = this.new_kotlin_Exception_hsqbop_k$(message);
        captureStack($this, $this.$throwableCtor_2);
        return $this;
      }
    }
    initMetadataForClass($, 'DriverActionException');
    DriverActionExceptionClass = $;
  }
  return DriverActionExceptionClass;
}
//region block: exports
export {
  DriverActionException as DriverActionException1ncfunkkb5qm9,
};
//endregion

//# sourceMappingURL=DriverActionException.mjs.map
